import React from "react";

import * as Styled from "./styles";

const SubmitButton = ({ text, onClick }) => {
  return <Styled.Button onClick={onClick}>{text}</Styled.Button>;
};

export default SubmitButton;
